import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerManualiModalComponent } from './worker-manuali-modal';


export const WorkerManualiModalModule: string = ng
    .module('worker-manuali-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerManualiModalComponent', WorkerManualiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-manuali-modal/worker-manuali-modal.module.ts